import { ApiResult, PaginatedResponse, request, safeRequest } from '@synergy/api';

import { ContactListItem } from '../models/contact-list-item';

export class ContactListApi {
    constructor(protected baseUrl: string) {}

    public getContacts(search: URLSearchParams): Promise<ApiResult<PaginatedResponse<ContactListItem>>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/contacts`, { params: search }),
            response => response.data
        );
    }
}
